import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { Decimal } from 'decimal.js';
import { Directive, Input } from '@angular/core';

/**
 * Validate the min number of a `input[type=text]`.
 * Number fields cannot be used because we can’t force English decimal point on them.
 */
@Directive({
    selector: '[pkpMinDecimalValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MinDecimalValidatorDirective,
            multi: true
        }
    ]
})
export class MinDecimalValidatorDirective implements Validator {
    @Input('pkpMinDecimalValidator') subject: Decimal.Value;

    validate(control: AbstractControl): ValidationErrors | null {
        try {
            return new Decimal(control.value).greaterThanOrEqualTo(this.subject)
                ? null
                : { pkpMinDecimalValidator: { value: control.value } };
        } catch (e) {
            return null;
        }
    }
}
